export default "__VITE_ASSET__Bvxks8cR__"